module.exports = {
    亚马逊: 'Amazon',
    沃尔玛: 'Walmart',
    星巴克: 'Starbucks',
    苹果卡: 'Apple',
    PayPal: 'Paypal',
    success: 'éxito',
    selected: 'Seleccionado',
    chooseGiftFirst: 'Elige primero una tarjeta de regalo: Apple o Starbucks.',
    综合评价: "Evaluación General",
    inputNotSame: "Entrada No Igual",
    example: 'Ejemplo',
    "btnPrev": "Anterior",
    // 选择语言
    popupTitle: 'Seleccionar idioma',
    // 发送
    send: 'Confirmar',
    // 发送邮件
    sendEmail: 'Enviar correo electrónico',
    // 改变语言
    changeLanSes: 'Cambio de idioma exitoso',
    // 中文
    chinese: '中文',
    // 法语
    french: 'Francais',
    // 英语
    english: 'English',
    // 德语
    german: 'Deutsch',
    // 西班牙语
    spanish: 'Espaiol',
    // 意大利语
    italian: 'Italiano',
    // 系统标题
    title: 'La voz del comprador',
    // 系统解释
    details: 'Escuchamos la voz de los compradores y ofrecemos productos y servicios de calidad.\n¡Gracias por acompañarnos!',
    fileSizeOver: "El archivo es demasiado grande, solo se admiten imágenes de hasta 10 MB.",
    lowTextarea: 'Sus comentarios nos ayudarán a mejorar continuamente nuestros productos y servicios.',
    placeholderOrderNo: "Introduzca el número de pedido (formato: 000-0000000-0000000)",
    "picUploadSuccessText": "Imagen subida con éxito",
    "picUploadErrorText": "Error al subir la imagen",
    "orderNotExistText": "El pedido no existe",
    "orderInvalidText": "Este pedido es inválido",
    "networkErrorText": "Error de red",
    "orderErrorText": "Error en el pedido",
    // step1
    formBasic: {
        confirm_btn: "Aceptar",
        "order_help_title": "Ayuda con el número de pedido",
    "order_help_content": "Si no conoce su número de pedido, póngase en contacto con nosotros para saber cómo obtenerlo. Nuestro correo electrónico: ",
        form_code: 'Código de verificación',
        form_code_placeholder: 'Por favor, introduzca el código de verificación',
        "get_code": "Obtener código",
  "code_sent_success": "Código enviado con éxito",
        "platform_name": "Nombre de la plataforma",
        "platform_name_placeholder": "Por favor, seleccione una plataforma",
  "form_name_placeholder": "Por favor, introduzca su nombre",
        title: 'Registre su garantía y<br><span style="color:#C9A127">reclame su regalo sorpresa</span>',
        form_name: 'Nombre',
        form_email: 'Correo electrónico',
        form_email_note: 'para recibir el regalo y obtener asistencia',
        form_order: 'Número de pedido',
        form_order_error_placeholder: "Introduzca el número de pedido (formato: 000-0000000-0000000)",
        order_why: '*¿Cómo encontrar su número de pedido?',
        order_answer: '*No compartimos su información personal con nadie.Su información personal está segura y se utiliza únicamente para la activación de la garantía.',
        btn_text: 'Activar ahora',
        "form_name_placeholder": "Por favor ingresa tu nombre",
        "form_email_placeholder": "Por favor ingresa tu correo electrónico",
        "form_email_error_placeholder": "Por favor ingresa un correo electrónico válido",
        "form_order_placeholder": "Por favor ingresa tu número de pedido"
    },
    // step2
    showGiftCard: {
        title: 'Su garantía extendida está activada.<br>Hemos añadido <strong>9 meses</strong> de cobertura a su producto.<br>¡Gracias por su compra!',
        text: '🎁 Reclama tu tarjeta regalo de 20 $ y comparte tu experiencia<br><small>(Tarda menos de 1 minuto)</small>',
        gift_card_text: 'Elige tu tarjeta regalo electrónica de 20 $',
        btn_text: 'Obtener mi recompensa'
    },
    // step3
    expectations: {
        title: "¡Gracias por elegir nuestros productos y servicios!",
        text: "Si cumple con sus expectativas o le da una pequeña sorpresa, ¿por qué no dedica unos segundos a dejar un comentario positivo en el sitio donde lo compró? ¡Deje un comentario positivo y reciba una tarjeta de regalo de $10!",
        btn_text: "Siguiente paso"
    },
    // step3
    star: {
        title: '¿Estás satisfecho con este producto o nuestro servicio?',
        text: 'Por favor, califica el producto con estrellas a continuación:',
        star__placeholder: '¡Por favor califique todas las preguntas antes de enviarlas!',
        written: 'Añadir una reseña escrita: <span style="color:#F40000">(Opcional)</span>',
        written_placeholder: '¿Qué te gustó? ¿Para qué usaste este producto?',
        btn_text: 'Siguiente paso'
    },
    // step4
    ensureEmail: {
        title: `Enhorabuena!</br>
Has terminado la encuesta.
`,
        text: `Por favor, confirme la dirección de correo electrónico, recibirá el código de regalo a través de esta dirección de correo electrónico:
customerservice8@yeah.net`,
        email_placeholder: "¡Por favor confirma nuevamente el correo electrónico!",
        btn_text: 'Confirmar'
    },
    // step5
    reviewGuide: {
        title: 'Cómo dejar una reseña en la plataforma de compra',
        subtitle: 'Selecciona tu plataforma para ver los pasos.'
    },
    channelSelect: {
        title: `¡Tu opinión importa! `,
        text: '¡Gracias por dejarnos su valiosa opinión! ¡Ahora puede elegir el regalo que desee!!!',
        footer: `*Sobre el regalo:</br>
Sin gastos de envío,Sin cargos ocultos,No requiere tarjeta de crédito`,
        btn_text: 'Lo quiero'
    },
    // step6
    uploadPic: {
        guideText: '¿Necesitas ayuda para hacer la captura de pantalla?<br><small>Selecciona tu plataforma de compra abajo para ver una guía rápida.</small>',
       "title": "Por favor, suba una captura de pantalla de su experiencia con el producto.",
  "text": "Para reclamar su tarjeta regalo de 20 $, solo tiene que enviar una captura de pantalla<br>de su reseña publicada a continuación.",
        add_pic: 'Haz clic para subir o arrastra y suelta',
        add_pic_text: 'JPG / PNG, hasta 10 MB',
        btn_text: 'Enviar y reclamar el regalo',
        uploading: 'Subiendo... Por favor espere',
        upload_required: 'Suba una captura de pantalla antes de continuar.',
        "no_file_selected": "Ningún archivo seleccionado"
    },
    // step7
    cityForm: {
        title: '*Dirección de recepción de accesorios: ',
        text: '(Plz confirmar su dirección de envío, el regalo será arreglado en 3-5 días laborables).',
        form_city: 'Ciudad',
        form_state: 'Estado/Región',
        form_postal_code: 'Código postal',
        form_country: 'País',
        btn_text: 'Confirme',
        "form_city_placeholder": "Por favor ingresa tu ciudad",
        "form_state_placeholder": "Por favor ingresa tu área",
        "form_postal_code_placeholder": "Por favor ingresa tu código postal",
        "form_country_placeholder": "Por favor ingresa tu país"
    },
    // step7
    paypalForm: {
        title: '¿A dónde debemos enviar tu tarjeta regalo de 20 $?',
        text: '(Asegúrate de que tus datos de PayPal sean correctos para evitar demoras.)',
        form_paypal: 'Cuenta de PayPal',
        form_ensure_paypal: 'Confirmar cuenta de PayPal',
        form_paypal_name: 'Nombre de la cuenta de PayPal',
        btn_text: 'Confirme',
        "form_paypal_placeholder": "Por favor ingresa tu cuenta PayPal",
        "form_ensure_paypal_placeholder": "Por favor confirma tu cuenta PayPal",
        "form_paypal_name_placeholder": "Por favor ingresa tu nombre PayPal"

    },
    // thanks-all
    thanksAll: {
        doneTitle: '¡Todo listo! 🎉', doneDescription: '¡Hemos recibido tu captura de pantalla! Tu solicitud de tarjeta regalo ya está en proceso.',
        request: 'Solicitud de tarjeta regalo', processing: 'En proceso', deliveryPrefix: 'Entrega estimada:', deliveryTime: '1-2 días laborables', deliverySuffix: 'por correo electrónico.',
        rewardTitle: 'Tu recompensa', rewardDescription: 'Enviaremos una tarjeta regalo electrónica de 20 $ a tu correo.',
        verifyStep: 'Verificaremos tu captura de pantalla en un plazo de 1-2 días laborables.', approvedStep: 'Una vez aprobada, te enviaremos la tarjeta regalo por correo electrónico.', spamStep: 'No olvides revisar la carpeta de spam/correo no deseado.', supportText: '¿Preguntas? Contacta con nuestro equipo de soporte en',
        "title": "¡Agradecidos por tu contribución!",
        // title_desc1: 'Gracias por participar en nuestra encuesta sobre productos.',
        // title_desc2: 'projector survey!',
        text: `Sus valiosas opiniones nos ayudarán a mejorar la calidad del producto. 
Si tiene alguna pregunta durante el uso, no dude en ponerse en contacto con nosotros.`
    },
    // thanks
    thanks: {
        "title1": "¡Felicidades!",
        title_desc1: `Su garantía está activada.
Muchas gracias por su tiempo.`,
        title_default_paypal_desc1: `Su garantía está activada.
Muchas gracias por su tiempo. Tu recompensa se emitirá en un plazo de 24 a 72 horas.`, 
        // title_desc2: 'Thank you very much for your time.',
    },
    // flow
    flow: {
        step1: 'Click to your homepage and click your orders',
        step2: 'Find the order of our store and click it',
        step3: 'Find the page of “Order info” and click “View order details”',
        step4: 'Order # is your order number, and you can copy the number and fill in our website',
    }
}
